<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/storeIntegrations/">Channels</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Channel</li>
    </ol>
  </nav>
  <div class="search-hero">
    <input
      class="form-control"
      type="text"
      name="search"
      [(ngModel)]="searchText"
      autocomplete="off"
      placeholder="  Start searching Channels">
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box connect-bg3">
        <h2 class="text-black mt-3 mb-5">Connect your Sales Channel</h2>
        <div class="market-place-box market-place-box2 market-place-box3">

          <div class="place-box" *ngFor="let connection of storeConnectionList">
            <figure><img src={{connection.imageUrl}}></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button (click)="routing(connection.carrierName)" type="button" class="btn btn-orange mt-2" *ngIf="connection.disable === true">Connect</button>
            <button type="button" class="btn btn-orange mt-2" *ngIf="connection.disable !== true" disabled>Coming Soon</button>
          </div>

          <!--<div class="place-box">
            <figure> <img src="assets/images/SHOPIFY.png"> </figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/shopifyUser/4">Connect</button>
          </div>-->

         <!-- <div class="place-box">
            <figure><img src="assets/images/AMAZON.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2"  routerLink="/admin/amazonUser/3">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/SHOPCLUES.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2"  routerLink="/admin/shopcluesUser/5">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/FLIPKART.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2"  routerLink="/admin/flipkartUser/2">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/SNAPDEAL.PNG"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/snapDealUser/9">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/BIGCOMMERCE.PNG"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/bigCommerceUser/2" >Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/WOOCOMMERCE.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/woocommerceUser/8" >Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/OPENCART.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/opencartUser/9" >Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/PRESTASHOP.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2"  routerLink="/admin/prestaShopUser/10">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/STOREHIPPO.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/storeHippo/11">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/I_GOOGLESHEET.png"></figure>
            <p>Use Google Sheets to create and edit online spreadsheets. </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/googleSheet/12">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/UNICOMMERCE.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled  >Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/ZOHO.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/zohoCommerceUser/10" >Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/SHIPROCKET.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled  >Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/firstcry.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery</p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/jollychic.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/messho.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/ajio.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/myntra.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/limeroad.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/jignov.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/snapmint.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/rediff.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/dalmia.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/maccaron.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/mirraw.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/simsim.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/amazonflex.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/glowroad.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/fynd.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/blibli.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/tataq.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/trell.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/travosh.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/jabong.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/voonik.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/spoyl.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>
          <div class="place-box">
            <figure><img src="assets/images/lazada.png"></figure>
            <p>Sync your inventory and order, stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

-->
        </div>
      </div>
    </div>
  </div>
</section>
